module.exports = __webpack_public_path__ + "img/image1.a43014c.png";